export default {
  full: 'Full Plans',
  slack: 'Slack Only'
}
